import IconButton, { IconButtonTypeMap } from '@material-ui/core/IconButton';
import { ExtendButtonBase } from '@material-ui/core/ButtonBase';

import CloseIcon from '@material-ui/icons/Close';

const Close: ExtendButtonBase<
  IconButtonTypeMap<Record<string, unknown>, 'button'>
> = (props) => {
  return (
    <IconButton
      {...props}
      style={{ margin: '10px 10px 10px auto' }}
      color="inherit"
    >
      <CloseIcon color="inherit" />
    </IconButton>
  );
};

export default Close;
